import React from "react";
import BookList from "../../Components/bookList/BookList";
import * as style from "./style.less";
import { UserPanel, useUserPanel } from "../../../../identity/User/Panel";
import { useNavigate } from "react-router";

export const NarrationHome = () => {
  const { isUserPanelOpened, closePanel } = useUserPanel();
  const navigate = useNavigate();
  const openProject = (projectId: string) => {
    navigate("/audio/library/edit/" + projectId + "/1", { replace: true });
  };

  return (
    <div className={style.narrationAppContainer}>
      <UserPanel closePanel={closePanel} isUserPanelOpened={isUserPanelOpened} />
      <div className={style.homeContainer}>
        <BookList openProject={openProject} />
      </div>
    </div>
  );
};
